import { getEvents, getPromoters } from '../../../api/ApiManager';
import camelcaseKeysDeep from 'camelcase-keys-deep';

import cloneDeep from 'lodash/cloneDeep';

import { browserHistory } from 'react-router';
import filter from 'lodash/filter';
import Moment from 'moment';

import Logger from '../../../common/lib/Logger';
import { flags } from '../../../common/constants/flags';

import { selectFeatureFlag } from '@flopflip/react-redux';

import { updateNotifications } from '../../EventDetails/modules/eventDetails';

export const LOAD_EVENTS_BEGIN = 'LOAD_EVENTS_BEGIN';
export const LOAD_EVENTS_SUCCESS = 'LOAD_EVENTS_SUCCESS';
export const LOAD_EVENT_CHRON_PAGE = 'LOAD_EVENT_CHRON_PAGE';

export const SORT_EVENT_CHRON = 'SORT_EVENT_CHRON';
export const FILTER_EVENT_CHRON = 'FILTER_EVENT_CHRON';

export const DIRECT_TO_EVENTS_LISTING = 'DIRECT_TO_EVENTS_LISTING';

export const RESET_EVENT_FETCH_TIMER = 'RESET_EVENT_FETCH_TIMER';
export const RESET_EVENT_LISTING_FILTER = 'RESET_EVENT_LISTING_FILTER';

export const LOAD_PROMOTERS_SUCCESS = 'LOAD_PROMOTERS_SUCCESS';
export const LOAD_PROMOTERS_FAILURE = 'LOAD_PROMOTERS_FAILURE';
export const LOAD_PROMOTERS_BEGIN = 'LOAD_PROMOTERS_BEGIN';

export const resetEventListing = () => {
  return { type: RESET_EVENT_LISTING_FILTER };
};
export const loadEventsStarted = () => {
  return { type: LOAD_EVENTS_BEGIN };
};

export const eventsLoadedSuccess = (events, eventsType) => {
  return { type: LOAD_EVENTS_SUCCESS, events, eventsType };
};

export const loadPromotersStarted = () => {
  return { type: LOAD_PROMOTERS_BEGIN };
};

export const loadPromotersSuccess = (promoters) => {
  return { type: LOAD_PROMOTERS_SUCCESS, promoters };
};

export const loadPromotersFailure = (err) => {
  return { type: LOAD_PROMOTERS_FAILURE, err };
};

export const loadEventChronPage = (page) => {
  return { type: LOAD_EVENT_CHRON_PAGE, page };
};

export const sortEventChron = (column) => {
  return { type: SORT_EVENT_CHRON, column };
};

export const filterEventChron = (filter, events) => {
  return { type: FILTER_EVENT_CHRON, filter, events };
};

export const directToEventsListing = () => {
  browserHistory.push('/events');
  return { type: DIRECT_TO_EVENTS_LISTING };
};

export const loadEvents = (withCms) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    if (contextId) {
      dispatch(loadEventsStarted());
      getEvents(contextId, withCms)
        .then((response) => {
          if (response.data.Events) {
            const cmsOnlyEvents = [];
            const events = [...response.data.Events].map((item) => {
              if (!item.LookupId) {
                item.LookupId = '';
              }
              // Hoist up portal event data.
              if (
                item.AXSEvent &&
                item.AXSEvent.EventId &&
                Number(item.Id) === 0
              ) {
                item.EventName = item.AXSEvent.Title.EventTitleText;
                item.PortalId = item.AXSEvent.EventId;
                item.PortalEvent = true;
                cmsOnlyEvents.push(item);
              }
              const sortableDate =
                item.AXSEvent && item.AXSEvent.EventDateTime
                  ? Moment(
                      item.AXSEvent.EventDateTime,
                      'YYYYMMDDTHHmmss'
                    ).format('YYYYMMDDHHmm')
                  : Moment(item.StartDate, 'YYYYMMDDTHHmmss').format(
                      'YYYYMMDDHHmm'
                    );
              return { ...item, SortableDate: sortableDate };
            });
            const formattedEvents = events.map((event) =>
              camelcaseKeysDeep(event)
            );
            const formattedCmsOnlyEvents = cmsOnlyEvents.map((event) => {
              return camelcaseKeysDeep(event);
            });
            withCms
              ? dispatch(eventsLoadedSuccess(formattedCmsOnlyEvents, 'cmsOnly'))
              : dispatch(eventsLoadedSuccess(formattedEvents));
          } else {
            dispatch(
              updateNotifications(
                response.data.ResponseStatus.Message,
                'error',
                true
              )
            );
            dispatch(eventsLoadedSuccess([]));
          }
        })
        .catch(() => {
          dispatch(
            updateNotifications(
              'An error has occurred loading the events.',
              'error',
              true
            )
          );
        });
    }
  };
};

export const loadPromoters = () => {
  return (dispatch, getState) => {
    dispatch(loadPromotersStarted());
    const contextId = getState().app.contextId;
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    getPromoters(contextId).then((response) => {
      const noError =
        response && response.data.hasOwnProperty('EventPromoters');
      if (noError) {
        const promoters = cloneDeep(response.data.EventPromoters);
        dispatch(loadPromotersSuccess(camelcaseKeysDeep(promoters)));
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications(
            'An error has occurred loading the Promoters ',
            'error',
            true
          )
        );
        dispatch(
          loadPromotersFailure('An error has occurred loading the Promoters.')
        );
      }
    });
  };
};

export const resetEventFetchTimer = () => {
  return { type: RESET_EVENT_FETCH_TIMER };
};

const ACTION_HANDLERS = {
  [LOAD_EVENTS_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },

  [LOAD_EVENTS_SUCCESS]: (state, action) => {
    const venues = action.events
      .map((event) => {
        return {
          value: event.venueId,
          key: event.venueId,
          text: event.venue,
        };
      })
      .filter(
        (venue, i, self) => i === self.findIndex((t) => t.text === venue.text)
      );
    venues.sort((a, b) =>
      a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1
    );
    venues.unshift({ key: 0, value: 0, text: 'All venues' });
    const filteredEvents = action.events.filter((event) => {
      const eventDate =
        event.id === 0 ? event.aXSEvent.eventDateTime : event.startDate;
      return new Date(eventDate) > Date.now();
    });
    return Object.assign({}, state, {
      events: action.events,
      venues,
      filteredEvents,
      isLoading: false,
      lastFetched: new Date(),
      eventsType: action.eventsType,
    });
  },
  [LOAD_EVENT_CHRON_PAGE]: (state, action) => {
    return Object.assign({}, state, { currentPage: action.page });
  },
  [LOAD_PROMOTERS_SUCCESS]: (state, action) => {
    return Object.assign({}, state, { promoters: action.promoters });
  },
  [SORT_EVENT_CHRON]: (state, action) => {
    const sortDir =
      action.column === state.sortByColumn
        ? state.sortDir === 'ASC'
          ? 'DESC'
          : 'ASC'
        : state.sortDir;

    return Object.assign({}, state, {
      sortByColumn: action.column,
      sortDir: sortDir,
      currentPage: 0,
    });
  },
  [FILTER_EVENT_CHRON]: (state, action) => {
    const events = action.events;
    const filterKeyword = (events) => {
      const keyword = action.filter.keyword;
      return keyword
        ? events.filter((event) => {
            return (
              (event.eventName &&
                event.eventName.toLowerCase().indexOf(keyword.toLowerCase()) !==
                  -1) ||
              (event.lookupId &&
                event.lookupId.toLowerCase().indexOf(keyword.toLowerCase()) !==
                  -1)
            );
          })
        : events;
    };

    const filterVenue = (events) => {
      return action.filter.venue !== 0
        ? filter(events, { venueId: action.filter.venue })
        : events;
    };

    const filterByDate = (events) => {
      let filteredEvents;
      switch (action.filter.time) {
        case 'All':
          filteredEvents = events;
          break;
        case 'Upcoming':
          filteredEvents = events.filter((event) => {
            const eventDate =
              event.id === 0 ? event.aXSEvent.eventDateTime : event.startDate;
            return new Date(eventDate) > Date.now();
          });
          break;
        case 'Past':
          filteredEvents = events.filter((event) => {
            const eventDate =
              event.id === 0 ? event.aXSEvent.eventDateTime : event.startDate;
            return new Date(eventDate) < Date.now();
          });
          break;
        default:
          break;
      }
      return filteredEvents;
    };

    const filteredEvents = filterByDate(filterVenue(filterKeyword(events)));

    return Object.assign({}, state, {
      filteredEvents: filteredEvents,
      venueFilter: action.filter.venue,
      timeFilter: action.filter.time,
      keywordFilter: action.filter.keyword,
      currentPage: 0,
    });
  },
  [DIRECT_TO_EVENTS_LISTING]: (state) => {
    return Object.assign({}, state);
  },
  [RESET_EVENT_FETCH_TIMER]: (state) => {
    return Object.assign({}, state, { lastFetched: null });
  },
  [RESET_EVENT_LISTING_FILTER]: (state) => {
    return Object.assign(
      {},
      initialState,
      { lastFetched: state.lastFetched },
      { events: state.events },
      { venues: state.venues },
      { filteredEvents: state.events }
    );
  },
};

export const initialState = {
  currentPage: 0,
  entriesPerPage: 50,
  events: [],
  promoters: [],
  eventsType: '',
  filteredEvents: [],
  isLoading: false,
  sortByColumn: 'eventName',
  sortDir: 'ASC',
  timeFilter: 'Upcoming',
  lastFetched: null,
  keywordFilter: '',
  venueFilter: 0,
  times: [
    {
      key: 0,
      value: 'Upcoming',
      text: 'Upcoming events',
    },
    {
      key: 1,
      value: 'Past',
      text: 'Past events',
    },
    {
      key: 2,
      value: 'All',
      text: 'All events',
    },
  ],
};

export default function chronReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Events/modules/eventChron.js